import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App.tsx";
import "./styles/index.css";
import { QueryProvider } from "./providers/query-providers.tsx";
import { installGlobalLogHandlers, logEvent } from "./lib/client-log.ts";
import "react-big-calendar/lib/css/react-big-calendar.css";

Sentry.init({
  dsn: "https://6cb958fedc832991ee1f4009faa1f95f@o4504740812619776.ingest.us.sentry.io/4511330381529088",
  environment: import.meta.env.MODE,
  release: import.meta.env.VITE_SENTRY_RELEASE as string | undefined,

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
  ],

  tracesSampleRate: 0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,

  sendDefaultPii: true,

  beforeSend(event) {
    if (event.request?.data && typeof event.request.data === "object") {
      const d = event.request.data as Record<string, unknown>;
      for (const k of ["password", "otp", "emailOtp", "token", "key", "newPassword"]) {
        if (d[k]) d[k] = "[Filtered]";
      }
    }
    if (event.request?.headers) {
      const h = event.request.headers as Record<string, string>;
      for (const k of Object.keys(h)) {
        const lk = k.toLowerCase();
        if (lk === "authorization" || lk === "cookie" || lk.startsWith("auth.")) {
          h[k] = "[Filtered]";
        }
      }
    }
    return event;
  },
});

// Axiom (via the API) sits alongside Sentry: Sentry groups crashes, Axiom keeps
// the full request/result trail that a non-crashing bug leaves behind.
installGlobalLogHandlers();
logEvent({ kind: "app_boot", mode: import.meta.env.MODE });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <BrowserRouter basename="/">
    <Sentry.ErrorBoundary fallback={<p style={{ padding: 24 }}>Something went wrong. Our team has been notified.</p>}>
      <QueryProvider>
        <App />
      </QueryProvider>
    </Sentry.ErrorBoundary>
  </BrowserRouter>
);
